
import api from "../../utils/api";  // Your Axios instance with default config

const API_BASE_URL = "/admin/ADPModPrefixNo"; 

const ADPModprefixnoService = {
 
  async findAll(): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-all`, {
      withCredentials: true
    });
    return response.data;
  },

 
  async getItemById(moduleId: string, documentType: string): Promise<any> {
    const response = await api.get(
      `${API_BASE_URL}/find-one/${moduleId}/${documentType}`
    );
    return response.data;
  },


  async create(item: any): Promise<any> {
    const response = await api.post(`${API_BASE_URL}/create`, item);
    return response.data;
  },


  async update(moduleId: string, documentType: string, item: any): Promise<any> {
    const response = await api.put(
      `${API_BASE_URL}/update/${moduleId}/${documentType}`,
      item
    );
    return response.data;
  },

  async updateList(): Promise<any> {
    const response = await api.put(
      `${API_BASE_URL}/updateList`
    );
    return response.data;
  },

 
  async delete(moduleId: string, documentType: string): Promise<any> {
    const response = await api.delete(
      `${API_BASE_URL}/delete/${moduleId}/${documentType}`
    );
    return response.data;
  }
};

export default ADPModprefixnoService;
